import React from 'react';
import {
  FooterContainer,
  FooterContent,
  FooterLeft,
  FooterCenter,
  FooterRight,
  FooterLink,
  FooterText,
  FooterBottom,
  SocialLogo,
  WebsiteRights,
} from './Footer.elements';
import logo from '../../assets/img/brand/SeaFarerInternetService5.png';
import { AppConfiguration } from "read-appsettings-json";

class Footer extends React.Component {
  render() {
    return (
      <FooterContainer>
        <FooterContent>
          <FooterLeft>
            <SocialLogo to='/home'>
              <img src={`${process.env.PUBLIC_URL}/SeaFarerInternetService_1.png`} />
              {/* <span style={{ marginLeft: 10, fontSize: 14 }}>{AppConfiguration.Setting().LongAppName}</span> */}
            </SocialLogo>
          </FooterLeft>
          
          <FooterCenter>
            <FooterText>
             <i className="fa fa-phone" aria-hidden="true" style={{ marginRight: 8 }}></i>
              +959 750230494
            </FooterText>
            <FooterText>
              <i className="fa fa-envelope-o" aria-hidden="true" style={{ marginRight: 8 }}></i>
              minsoemin1111@gmail.com
            </FooterText>
          </FooterCenter>
          
          <FooterRight>
            <FooterLink to='/home/contact'>
              <i className="fa fa-comments" aria-hidden="true" style={{ marginRight: 8 }}></i>
              Get in Touch
            </FooterLink>
            <FooterLink to='/home/faq'>
              <i className="fa fa-question-circle" aria-hidden="true" style={{ marginRight: 8 }}></i>
              FAQ
            </FooterLink>
          </FooterRight>
        </FooterContent>
        
        <FooterBottom>
          <WebsiteRights>{`© ${new Date().getFullYear()} Seafarerinternetservice All Right Reserved.`}</WebsiteRights>
        </FooterBottom>
      </FooterContainer>
    );
  }
}

export default Footer;